export const sdkDebuggerAppGroupIdAll = "/sdk/debugger/:app_group_id/all";
